module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p8",
      "title": "8"
    }
  }, [_c('h2', {
    staticClass: "head_1"
  }, [_vm._v("How to Freeze and Thaw")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Not all foods are great freezer candidates. Know which foods are freezer-worthy and which are not.")]), _vm._v(" "), _c('h3', {
    staticClass: "head2"
  }, [_vm._v("FREEZER-FRIENDLY FOODS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("These foods get good marks for their freeze-ability. To freeze a dish that’s a combination of ingredients, freeze it for the length of time given for the ingredient that can be frozen for the least amount of time. Use the chart below to know how long you can freeze at 0°F or below.")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v("Food")]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("Freeze Time")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Bacon, cured")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("1 month")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Bananas, raw, whole")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("2 to 3 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Berries")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("10 to 12 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Cakes")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Cheese \n"), _c('ul', {
    staticClass: "ul3"
  }, [_c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Hard cheese or unopened shredded")])])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("2 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Cheesecakes")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("4 to 5 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Fish\n"), _c('ul', {
    staticClass: "ul3"
  }, [_c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Uncooked")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Cooked and Breaded")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Uncooked Shellfish")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Cooked Shellfish")])])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("3 to 6 months")]), _vm._v(" "), _c('li', [_vm._v("2 to 3 months")]), _vm._v(" "), _c('li', [_vm._v("3 to 4 months")]), _vm._v(" "), _c('li', [_vm._v("1 to 2 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Ginger, fresh, whole, unpeeled")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("6 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Herbs, fresh*\n"), _c('ul', {
    staticClass: "ul3"
  }, [_c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("basil, chives, dill, lemon balm, lemongrass, mint, oregano, sage, savory, thyme")])])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("3 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Hot Dogs")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("1 to 2 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Meat\n"), _c('ul', {
    staticClass: "ul3"
  }, [_c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Chops, uncooked")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Ground, uncooked")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Ground, cooked")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Roasts and steaks, uncooked")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Roasts and steaks, cooked")])])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("4 to 6 months")]), _vm._v(" "), _c('li', [_vm._v("3 to 4 months")]), _vm._v(" "), _c('li', [_vm._v("4 months")]), _vm._v(" "), _c('li', [_vm._v("6 to 12 months")]), _vm._v(" "), _c('li', [_vm._v("2 to 3 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Pancakes and Waffles")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("2 to 3 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Pasta, cooked in sauce")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("1 to 2 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Pies and Pastry\n"), _c('ul', {
    staticClass: "ul3"
  }, [_c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Dough or Unbaked Pie Shells")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Baked Pie Shells")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Unbaked and Baked Fruit Pies")]), _vm._v(" "), _c('li', {
    staticClass: "font_italic1"
  }, [_vm._v("Baked Pecan and Pumpkin Pies")])])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("2 months")]), _vm._v(" "), _c('li', [_vm._v("4 months")]), _vm._v(" "), _c('li', [_vm._v("4 months")]), _vm._v(" "), _c('li', [_vm._v("4 months")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("Rice, cooked")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("1 month")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Soups, Stews, Stocks and Chili")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('ul', {
    staticClass: "ul3"
  }, [_c('li', [_vm._v("2 to 3 months")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "table_note"
  }, [_vm._v("*See "), _c('span', {
    attrs: {
      "href": "#/html/p216#freezingherbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Freezer Ideas")]), _vm._v(" for directions on freezing herbs.")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p9",
      "title": "9"
    }
  }, [_c('h3', {
    staticClass: "head2"
  }, [_vm._v("UNFRIENDLY FREEZER FOODS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("These ingredients don’t fare well through the freeze/thaw process because the food becomes mushy, separates or is watery, so you wouldn’t want to eat it. Avoid freezing these foods:")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Cream or custard fillings")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Dairy products—except for butter and cheese")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Eggs—fresh, whole or hard-boiled")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Icings made from egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Fruits and veggies (high moisture)—such as celery, lettuce, watermelon")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Jam")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Potatoes, Idaho or russet, raw")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "listunmarked"
  }, [_vm._v("Meringue")]), _vm._v(" "), _c('h3', {
    staticClass: "head2"
  }, [_vm._v("RULES OF THE THAW")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("If you cook from your freezer on a regular basis, consider moving tomorrow night’s meal from the freezer to the fridge while cleaning up from tonight’s meal. It’s best to thaw frozen food in the refrigerator, never on the counter or it can set you up for food-safety issues. Allow 12 to 24 hours for meals to thaw completely. Bake foods 5 to 10 minutes longer than directed in the recipe to account for the cold ingredients. Some foods, like soup or chili, will thicken during storage. If this is the case, simply add a little broth, water, milk or half-and-half until the soup reaches the desired consistency.")]), _vm._v(" "), _c('h2', {
    staticClass: "head3"
  }, [_vm._v("IF IN DOUBT, THROW IT OUT")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Freezing doesn’t kill bacteria, and improper thawing can cause bacteria to grow. So if you are unsure how long something has been frozen or question whether something was thawed and not used soon enough, don’t take any chances and discard it.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('figure', {
    staticClass: "fullpage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p009.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a33b35ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p008.vue
// module id = 78
// module chunks = 0